<div class="content-layout" [brightsideWebFb]="{ event_name: fbEventName + '_shown' }">
  <bw-action-article-legacy>
    <ui-nav-exit-back
      header-actions
      [trackingDetail]="{ event_name: fbEventName + '_dismissed' }"
      (exitActionHandler)="handleTryAnotherSecondaryCtaClick()"
    >
    </ui-nav-exit-back>

    <div pre-title>
      <bw-steps-legacy
        *ngIf="pageStepperActiveIndex >= 0"
        styleClass="mb-md"
        [model]="pageStepperItems"
        [readonly]="true"
        [activeIndex]="pageStepperActiveIndex"
      ></bw-steps-legacy>
    </div>
    <div header-title class="mb-sm">
      <typography-legacy title-medium>{{ pageTitle }}</typography-legacy>
    </div>
    <div content-section>
      <p class="secondary-text mb-md">{{ pageSubTitle }}</p>

      <form [formGroup]="routingForm" autocomplete="off">
        <div class="form-grid">
          <bw-input-legacy
            [isCustomControl]="true"
            label="{{ 'MICRO_VERIFY_ACCOUNT_AMOUNT_LABEL' | translate : { counter: 1 } }}"
            [inputError]="(amountOne?.invalid && amountOne?.touched) || showError"
            inputErrorText="{{ 'MICRO_VERIFY_ACCOUNT_DEPOSIT_AMOUNT_ERROR' | translate }}"
          >
            <input
              type="text"
              class="body"
              formControlName="amountOne"
              currencyMask
              [options]="microVerifyCurrencyMask"
            />
          </bw-input-legacy>

          <bw-input-legacy
            [isCustomControl]="true"
            label="{{ 'MICRO_VERIFY_ACCOUNT_AMOUNT_LABEL' | translate : { counter: 2 } }}"
            [inputError]="(amountTwo?.invalid && amountTwo?.touched) || showError"
            inputErrorText="{{ 'MICRO_VERIFY_ACCOUNT_DEPOSIT_AMOUNT_ERROR' | translate }}"
          >
            <input
              type="text"
              class="body"
              formControlName="amountTwo"
              currencyMask
              [options]="microVerifyCurrencyMask"
            />
          </bw-input-legacy>
        </div>
      </form>
    </div>
    <div footer-actions class="flex-row row-reverse">
      <button
        *ngIf="pageCtaLabel"
        bw-button-legacy
        type="submit"
        [disabled]="routingForm.invalid"
        [processing]="processing"
        (click)="handleCtaClick()"
      >
        {{ pageCtaLabel }}
      </button>

      <typography-legacy text-large-semibold>
        <button *ngIf="pageSecondaryCtaLabel" bw-link-button-legacy class="bs-blue brand pr-xl" (click)="handleSecondaryCtaClick()">
          {{ pageSecondaryCtaLabel }}
        </button>
      </typography-legacy>
    </div>
  </bw-action-article-legacy>
</div>

<bw-modal-legacy *ngIf="showResend" modalWidth="medium">
  <typography-legacy title-medium color="var(--bs-dark-gray)" class="mb-sm">{{
    'MICRO_VERIFY_ACCOUNT_SHOW_RESEND_TITLE' | translate
  }}</typography-legacy>
  <section class="body">
    <bw-paragraph-legacy>
      <typography-legacy text-large-regular color="var(--primary-text)">{{ resendLineWithDate }}</typography-legacy>
    </bw-paragraph-legacy>
    <bw-paragraph-legacy>
      <typography-legacy text-large-regular color="var(--primary-text)">{{
        'MICRO_VERIFY_ACCOUNT_SHOW_RESEND_TEXT_LINE_1' | translate
      }}</typography-legacy>
    </bw-paragraph-legacy>
    <bw-paragraph-legacy>
      <typography-legacy text-large-regular color="var(--primary-text)">{{
        'MICRO_VERIFY_ACCOUNT_SHOW_RESEND_TEXT_LINE_2' | translate : { resendTimesLeft: this.resendTimesLeft }
      }}</typography-legacy>
    </bw-paragraph-legacy>
  </section>
  <footer class="footer">
    <div class="flex-row row-reverse">
      <button *ngIf="resendPrimaryCta" bw-button-legacy [processing]="processing" (click)="handleResendCtaClick()">
        {{ resendPrimaryCta }}
      </button>

      <button *ngIf="resendSecondaryCta" bw-link-button-legacy class="bs-blue pr-xl" (click)="showResend = false">
        {{ resendSecondaryCta }}
      </button>
    </div>
  </footer>
</bw-modal-legacy>

<bw-modal-legacy *ngIf="showTryAnotherWay" modalWidth="medium">
  <typography-legacy title-medium color="var(--bs-dark-gray)" class="mb-sm">{{
    'MICRO_VERIFY_ACCOUNT_SHOW_ANOTHER_WAY_TITLE' | translate
  }}</typography-legacy>
  <section class="body">
    <bw-paragraph-legacy>
      <typography-legacy text-large-regular color="var(--primary-text)">
        {{ 'MICRO_VERIFY_ACCOUNT_SHOW_ANOTHER_WAY_TEXT_LINE_1' | translate }}
      </typography-legacy>
    </bw-paragraph-legacy>
  </section>
  <footer class="footer">
    <div class="flex-row row-reverse">
      <button bw-button-legacy [processing]="processing" (click)="handleTryAnotherCtaClick()">
        {{ 'MICRO_VERIFY_ACCOUNT_FOOTER_CTA' | translate }}
      </button>

      <button *ngIf="resendSecondaryCta" bw-link-button-legacy class="bs-blue pr-xl" (click)="handleTryAnotherSecondaryCtaClick()">
        {{ 'MICRO_VERIFY_ACCOUNT_FOOTER_SECONDARY_CTA' | translate }}
      </button>
    </div>
  </footer>
</bw-modal-legacy>
